// extracted by mini-css-extract-plugin
export default {"buttons":"ProceedModal_buttons__+iP6c","description":"ProceedModal_description__itCw8","container":"ProceedModal_container__Ybl7v"};